  


<ng-container *ngIf="floatLabel">
  <div class="p-float-label">
    <ng-container *ngTemplateOutlet="input"></ng-container>
    <label for="timeInput">{{ floatLabel }}</label>
  </div>
</ng-container>
<ng-container *ngIf="!floatLabel">
  <ng-container *ngTemplateOutlet="input"></ng-container>
</ng-container>

<ng-template #input>
  <p-inputMask
    #timeInput
    *ngIf="FC"
    [formControl]="FC"
    mask="99:99"
    placeholder="HH:MM"
    slotChar="HH:MM"
    [styleClass]="styleClass"
    [autoClear]="false"
    (keydown)="onTimeKeyDown($event)"
    id="timeInput">
  </p-inputMask>
</ng-template>